import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

export const useSecurityComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignCenter: {
      '& *': {
        textAlign: 'center',
      },
    },
    offset: {
      marginBottom: theme.spacing(2.5),
      '& .MuiOutlinedInput-root': {
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
          },
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 2,
          },
        },
      },
    },
    labelHolder: {
      overflow: 'hidden',
      marginBottom: theme.spacing(1.5),
      color: theme.palette.text.secondary,
      fontStyle: 'italic',
      fontSize: '0.875rem',
    },
    securityComponentHolder: {
      margin: '0 auto',
      maxWidth: 500,
    },
    btnHolder: {
      maxWidth: 280,
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: theme.spacing(3),
      '& .MuiButton-root': {
        borderRadius: theme.shape.borderRadius * 2,
        padding: theme.spacing(1.5, 4),
        fontWeight: 600,
        fontSize: '0.9375rem',
        textTransform: 'none',
      },
    },
    activateLinkHolder: {
      position: 'relative',
    },
    activateLinkLoader: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: 8,
      left: 120,
      zIndex: 1,
    },
  })
)
